export const API_BASE_URL = "https://tamilvokkaligamatrimony.com";


// export const API_BASE_URL = "http://192.168.1.24:5000";

